import Relay from 'react-relay';

export class CompleteMutation extends Relay.Mutation {
  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
        primaryBorrower{
          email
        }
        activeLoan{
          scenario
        }
      }
    `
  };
  getMutation() {
    return Relay.QL`mutation{complete}`;
  }
  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id
        }
      }
    ];
  }
  getFatQuery() {
    return Relay.QL`
      fragment on CompletePayload {
        viewer { 
          id,
          consultPath
          advisor
          products {
            apr
            rate
            loanTerm            
            amortizationType
          }
        }
      }
    `;
  }
  getVariables() {
    return { id: this.props.viewer.id };
  }
}



// WEBPACK FOOTER //
// ./src/products/shared/mutation.js